import InputRender from '@/mixin/render-input.js'
export default {
    data () {
        return {
            type: 'Chiller_Qunty_Type',

            paramsList: [
                {
                    title: '冷冻机规格1',
                    prop: 'Chiller_Type_1',
                    Brand: 'York',  // 厂商
                    Model: '0050010120',  // 型号
                    disabled: false,
                    list: [
                        {
                            title: '类型',
                            prop: 'Compressor_Type',
                            type: 'select',
                            vModel: '0',
                            selectList: [
                                { label: '单级离心', id: '0' },
                                { label: '两级离心', id: '1' },
                                { label: '三级离心', id: '2' },
                                { label: '顿布离心', id: '3' },
                                { label: '螺杆', id: '4' },
                            ],
                        },
                        {
                            title: '变频',
                            prop: 'Vsd_or_Csd',
                            type: 'radio',
                            vModel: '0',
                            radioList: [
                                { label: '定频', id: '0' },
                                { label: '变频', id: '1' },
                            ],
                        },
                        {
                            title: '数量',
                            prop: 'Chiller_Qunty_Type_1',
                            System_Configuration: true,
                            disabled: true,
                            type: 'input',
                            vModel: '1',
                        },
                        {
                            title: '单机制冷量(kw)',
                            prop: 'Q0',
                            type: 'input',
                            vModel: '2484.0',
                        },
                        {
                            title: '冷冻水出水温度(℃)',
                            prop: 'T1',
                            type: 'input',
                            vModel: '5.0',
                        },
                        {
                            title: '冷却水进口温度(℃)',
                            prop: 'T2',
                            type: 'input',
                            vModel: '32.0',
                        },
                        {
                            title: '冷冻水流量(m³/h)',
                            prop: 'L1',
                            type: 'input',
                            vModel: '425.9',
                        },
                        {
                            title: '冷却水流量(m³/h)',
                            prop: 'L2',
                            type: 'input',
                            vModel: '513.4',
                        },
                        {
                            title: '蒸发器压降(KPa)',
                            prop: 'dP_Evaporator',
                            type: 'input',
                            vModel: '66.9',
                        },
                        {
                            title: '冷凝器压降(KPa)',
                            prop: 'dP_Condenser',
                            type: 'input',
                            vModel: '66.8',
                        },
                        {
                            title: 'COP',
                            prop: 'COP',
                            type: 'input',
                            vModel: '4.85',
                        },
                        {
                            title: 'NPLV',
                            prop: 'NPLV',
                            type: 'input',
                            vModel: '5.263',
                        },
                        {
                            title: '最小制冷量(%)',
                            prop: 'Q0Rate_min',
                            type: 'input',
                            vModel: '0.15',
                        },
                        {
                            title: '最小冷冻水流量(%)',
                            prop: 'L1Rate_min',
                            type: 'input',
                            vModel: '0.15',
                        },
                        {
                            title: '最小冷却水流量(%)',
                            prop: 'L2Rate_min',
                            type: 'input',
                            vModel: '0.45',
                        },
                        {
                            title: '最低冷却水温度(℃)',
                            prop: 'T2_min',
                            type: 'input',
                            vModel: '13.0',
                        },
                    ],
                },

                {
                    title: '冷冻机规格2',
                    prop: 'Chiller_Type_2',
                    Brand: 'York',  // 厂商
                    Model: '0050013785',  // 型号
                    disabled: false,
                    list: [
                        {
                            title: '类型',
                            prop: 'Compressor_Type',
                            type: 'select',
                            vModel: '0',
                            selectList: [
                                { label: '单级离心', id: '0' },
                                { label: '两级离心', id: '1' },
                                { label: '三级离心', id: '2' },
                                { label: '顿布离心', id: '3' },
                                { label: '螺杆', id: '4' },
                            ],
                        },
                        {
                            title: '变频',
                            prop: 'Vsd_or_Csd',
                            type: 'radio',
                            vModel: '0',
                            radioList: [
                                { label: '定频', id: '0' },
                                { label: '变频', id: '1' },
                            ],
                        },
                        {
                            title: '数量',
                            prop: 'Chiller_Qunty_Type_2',
                            System_Configuration: true,
                            disabled: true,
                            type: 'input',
                            vModel: '2',
                        },
                        {
                            title: '单机制冷量(kw)',
                            prop: 'Q0',
                            type: 'input',
                            vModel: '2484.0',
                        },
                        {
                            title: '冷冻水出水温度(℃)',
                            prop: 'T1',
                            type: 'input',
                            vModel: '5.0',
                        },
                        {
                            title: '冷却水进口温度(℃)',
                            prop: 'T2',
                            type: 'input',
                            vModel: '32.0',
                        },
                        {
                            title: '冷冻水流量(m³/h)',
                            prop: 'L1',
                            type: 'input',
                            vModel: '425.9',
                        },
                        {
                            title: '冷却水流量(m³/h)',
                            prop: 'L2',
                            type: 'input',
                            vModel: '513.4',
                        },
                        {
                            title: '蒸发器压降(KPa)',
                            prop: 'dP_Evaporator',
                            type: 'input',
                            vModel: '66.9',
                        },
                        {
                            title: '冷凝器压降(KPa)',
                            prop: 'dP_Condenser',
                            type: 'input',
                            vModel: '66.8',
                        },
                        {
                            title: 'COP',
                            prop: 'COP',
                            type: 'input',
                            vModel: '4.85',
                        },
                        {
                            title: 'NPLV',
                            prop: 'NPLV',
                            type: 'input',
                            vModel: '5.263',
                        },
                        {
                            title: '最小制冷量(%)',
                            prop: 'Q0Rate_min',
                            type: 'input',
                            vModel: '0.15',
                        },
                        {
                            title: '最小冷冻水流量(%)',
                            prop: 'L1Rate_min',
                            type: 'input',
                            vModel: '0.15',
                        },
                        {
                            title: '最小冷却水流量(%)',
                            prop: 'L2Rate_min',
                            type: 'input',
                            vModel: '0.45',
                        },
                        {
                            title: '最低冷却水温度(℃)',
                            prop: 'T2_min',
                            type: 'input',
                            vModel: '13.0',
                        },
                    ],
                },

                {
                    title: '冷冻机规格3',
                    prop: 'Chiller_Type_3',
                    Brand: 'None',  // 厂商
                    Model: '0000000000',  // 型号
                    disabled: false,
                    list: [
                        {
                            title: '类型',
                            prop: 'Compressor_Type',
                            type: 'select',
                            vModel: '0',
                            selectList: [
                                { label: '单级离心', id: '0' },
                                { label: '两级离心', id: '1' },
                                { label: '三级离心', id: '2' },
                                { label: '顿布离心', id: '3' },
                                { label: '螺杆', id: '4' },
                            ],
                        },
                        {
                            title: '变频',
                            prop: 'Vsd_or_Csd',
                            type: 'radio',
                            vModel: '0',
                            radioList: [
                                { label: '定频', id: '0' },
                                { label: '变频', id: '1' },
                            ],
                        },
                        {
                            title: '数量',
                            prop: 'Chiller_Qunty_Type_3',
                            System_Configuration: true,
                            disabled: true,
                            type: 'input',
                            vModel: '0',
                        },
                        {
                            title: '单机制冷量(kw)',
                            prop: 'Q0',
                            type: 'input',
                            vModel: '2484.0',
                        },
                        {
                            title: '冷冻水出水温度(℃)',
                            prop: 'T1',
                            type: 'input',
                            vModel: '5.0',
                        },
                        {
                            title: '冷却水进口温度(℃)',
                            prop: 'T2',
                            type: 'input',
                            vModel: '32.0',
                        },
                        {
                            title: '冷冻水流量(m³/h)',
                            prop: 'L1',
                            type: 'input',
                            vModel: '425.9',
                        },
                        {
                            title: '冷却水流量(m³/h)',
                            prop: 'L2',
                            type: 'input',
                            vModel: '513.4',
                        },
                        {
                            title: '蒸发器压降(KPa)',
                            prop: 'dP_Evaporator',
                            type: 'input',
                            vModel: '66.9',
                        },
                        {
                            title: '冷凝器压降(KPa)',
                            prop: 'dP_Condenser',
                            type: 'input',
                            vModel: '66.8',
                        },
                        {
                            title: 'COP',
                            prop: 'COP',
                            type: 'input',
                            vModel: '4.85',
                        },
                        {
                            title: 'NPLV',
                            prop: 'NPLV',
                            type: 'input',
                            vModel: '5.263',
                        },
                        {
                            title: '最小制冷量(%)',
                            prop: 'Q0Rate_min',
                            type: 'input',
                            vModel: '0.15',
                        },
                        {
                            title: '最小冷冻水流量(%)',
                            prop: 'L1Rate_min',
                            type: 'input',
                            vModel: '0.15',
                        },
                        {
                            title: '最小冷却水流量(%)',
                            prop: 'L2Rate_min',
                            type: 'input',
                            vModel: '0.45',
                        },
                        {
                            title: '最低冷却水温度(℃)',
                            prop: 'T2_min',
                            type: 'input',
                            vModel: '13.0',
                        },
                    ],
                },
            ],
        }
    },
    mixins: [InputRender],

}